<template>
    <admin-layout>
        <template #header>
            <h2 class="text-xl font-semibold leading-tight text-white">
                Edit Book
            </h2>
        </template>
            <div class="w-full p-12 text-gray-700 bg-white rounded shadow-xl">
                <!-- form start -->
                <form @submit.prevent="submit">
                    <div class="md:flex md:justify-between md:mb-4">
                        <!-- book title -->
                        <div class="w-full md:pr-4">
                            <div class="mb-4">
                                <label class="w-full">
                                    <span class="text-base font-semibold text-gray-700">Title</span>
                                    <input type="text" v-model="form.title" class="block w-full p-3 mt-1 border border-gray-300 border-solid rounded focus:outline-none" placeholder="book name">
                                </label>
                            </div>
                            <!-- description -->
                            <div class="mb-4">
                                <label class="w-full">
                                    <span class="text-base font-bold text-gray-700">Description</span>
                                    <textarea v-model="form.description" class="block w-full p-3 mt-1 border border-gray-300 border-solid rounded focus:outline-none" rows="5" cols="10" placeholder="description...."></textarea>
                                </label>
                            </div>
                        </div>
                        <!-- cover image -->
                        <div class="w-full">
                            <span class="text-base font-semibold text-gray-700">Cover Image</span>
                            <label class="flex flex-col items-center justify-center w-full p-4 mt-1 tracking-wide uppercase bg-white border border-gray-300 rounded-lg cursor-pointer h-60 hover:bg-pink-600 hover:text-white">
                                <svg class="w-8 h-8" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                <path d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z"/>
                                </svg>
                                <span v-show="!showPreview" class="mt-2 text-base leading-normal">Aggiungi immagine</span>
                                <input type="file" name="picture" class="hidden" id="picture" @change="onFileChange">      
                                <img v-bind:src="imagePreview" class="w-24 h-24" v-show="showPreview"/> 
                            </label>
                        </div>
                    </div>
                    <!-- check of paid -->
                    <div class="my-4">
                        <div>
                            <label for="paid">
                                <strong>Prodotto a pagamento</strong>
                                <input class="ml-2" type="checkbox" name="paid" id="paid" v-model="form.is_paid">
                            </label>
                        </div>
                        <div>
                            <label v-if="form.is_paid === true || form.is_paid === 1" for="price">
                                <strong>Price<small>(coin)</small></strong>
                                <input type="number" v-model="form.price" class="block w-full p-3 mt-1 border border-gray-300 border-solid rounded focus:outline-none">
                            </label>
                        </div>
                    </div>
                    <!-- submit button -->
                    <div class="text-center">
                        <button type="submit" class="w-full px-10 py-2 text-base font-semibold text-center text-white bg-green-600 rounded-md">
                            save
                        </button>
                    </div>
                </form>
                <!-- form end -->
            </div>
    </admin-layout>
</template>

<script>
    import AdminLayout from '@/Layouts/AdminLayout'

    export default {
        props: ['book', 'product'],
        components: {
            AdminLayout,
        },
        data() {
            return {
                imagePreview: this.book.cover_photo_url,
                showPreview: true,
                form: this.$inertia.form({
                    id: this.book.id,
                    title: this.book.title,
                    description: this.book.description,
                    picture: this.book.cover_photo_url,
                    is_paid: this.book.is_paid,
                    price: this.product.price,
                }),
                message: '',
            }
        },
        methods: {
            onFileChange(event) {
                this.form.picture = event.target.files[0];
                let reader  = new FileReader();
                var size = parseFloat(this.form.picture.size / (1024 * 1024)).toFixed(2);
                
                if( this.form.picture ){
                    if( /\.(jpeg|jpg|png)$/i.test( this.form.picture.name ) ) {
                        this.message = "";
                        reader.addEventListener("load", function () {
                            this.showPreview = true;
                            this.imagePreview = reader.result;
                        }.bind(this), false);

                        if (size < 2) {
                            reader.readAsDataURL( this.form.picture );
                        } else {
                            this.message = "File size has exceeded it max limit of 2MB";
                        }
                    } else {
                        this.message = "only jpg, png and jpeg accepted";
                    }
                }
            },
            submit() {
                if(this.form.is_paid === false || this.form.is_paid == 0){
                    this.form.price = 0;
                }
                this.form.post(this.route('books.update'))
            },
        }
    };
</script>